import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf5f35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks-kanban-search-input" }

import { computed, ref, watch } from "vue";
import TirPmSearchInput from "tir-pm-search-input/src/TirPmSearchInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TasksKanbanSearchInput',
  props: {
  /**Сброс поиска */
  resetSearchState: {
    type: Boolean,
  },
  modelValue: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "onSearch"],
  setup(__props, { emit }) {

const props = __props;





const $searchInput = ref<InstanceType<typeof TirPmSearchInput>>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

watch(
  () => props.resetSearchState,
  () => {
    if (props.resetSearchState) $searchInput.value.value = "";
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createVNode(TirPmSearchInput, {
      ref_key: "$searchInput",
      ref: $searchInput,
      placeholder: "",
      label: __props.placeholder,
      class: "tasks-kanban-search-input__input",
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      isSmall: "",
      isWithPopup: false,
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('onSearch')), ["enter"])),
      isDisabled: props.isDisabled
    }, null, 8, ["label", "modelValue", "isDisabled"])
  ]))
}
}

})